import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { LazySection } from './components/LazySection';
// Lazy load ALL below-fold sections
const FrecuenciaSection = lazy(() => import('./components/FrecuenciaSection').then(m => ({
  default: m.FrecuenciaSection
})));
const CienciaSection = lazy(() => import('./components/CienciaSection').then(m => ({
  default: m.CienciaSection
})));
const TestimoniosSection = lazy(() => import('./components/TestimoniosSection').then(m => ({
  default: m.TestimoniosSection
})));
const IdentitySection = lazy(() => import('./components/IdentitySection').then(m => ({
  default: m.IdentitySection
})));
const ProtocoloSection = lazy(() => import('./components/ProtocoloSection').then(m => ({
  default: m.ProtocoloSection
})));
const HoyTeLlevasSection = lazy(() => import('./components/HoyTeLlevasSection').then(m => ({
  default: m.HoyTeLlevasSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SalesNotification = lazy(() => import('./components/SalesNotification').then(m => ({
  default: m.SalesNotification
})));
export function App() {
  const [upsellStep, setUpsellStep] = useState<'none' | 'upsell' | 'downsell'>('none');
  const [showNotification, setShowNotification] = useState(false);
  const URL_SOLO_EBOOK = 'https://www.betterdailyguides.com/cart/51937436041518:1';
  const URL_CON_UPSELL_FULL = 'https://www.betterdailyguides.com/cart/51937439318318:1';
  const URL_CON_UPSELL_DOWNSELL = 'https://www.betterdailyguides.com/cart/51937446101294:1';
  useEffect(() => {
    // Preconnect to critical origins FIRST (before any other logic)
    const origins = ['https://cdn.shopify.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://connect.facebook.net'];
    origins.forEach(origin => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
    // Preload LCP image immediately
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=280';
    preloadLink.setAttribute('fetchpriority', 'high');
    preloadLink.setAttribute('imagesrcset', 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=280 280w, ' + 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=350 350w, ' + 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=450 450w');
    preloadLink.setAttribute('imagesizes', '(max-width: 640px) 280px, (max-width: 1024px) 350px, 450px');
    document.head.appendChild(preloadLink);
    // DEFER Meta Pixel — non-critical, load after page is interactive
    const loadPixel = () => {
      const w = window as any;
      if (!w.fbq) {
        function fbq(...args: any[]) {
          if (fbq.callMethod) {
            fbq.callMethod.apply(fbq, args);
          } else {
            fbq.queue.push(args);
          }
        }
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [] as any[];
        fbq.callMethod = null as any;
        w.fbq = fbq;
        w._fbq = fbq;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      w.fbq('init', '919180517627113');
      w.fbq('track', 'PageView');
      // Noscript fallback
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=919180517627113&ev=PageView&noscript=1';
      document.body.appendChild(img);
    };
    // Use requestIdleCallback if available, otherwise setTimeout 2s
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 2000);
    }
    // Detect slow connection for notification timing
    const conn = (navigator as any).connection;
    const isSlow = conn && (conn.saveData || conn.effectiveType === '2g' || conn.effectiveType === 'slow-2g');
    // Defer sales notification
    const notifTimeout = setTimeout(() => setShowNotification(true), isSlow ? 12000 : 8000);
    return () => {
      clearTimeout(notifTimeout);
    };
  }, []);
  const handlePurchase = () => {
    setUpsellStep('upsell');
  };
  return <div className="min-h-screen bg-dark font-sans text-white selection:bg-gold/30 selection:text-gold overflow-x-hidden w-full" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[99999] focus:bg-gold focus:text-dark focus:px-4 focus:py-2 focus:rounded focus:font-bold" data-id="element-1">
        Saltar al contenido principal
      </a>
      <Navbar handlePurchase={handlePurchase} data-id="element-2" />
      <main id="main-content" className="overflow-x-hidden" data-id="element-3">
        <HeroSection handlePurchase={handlePurchase} data-id="element-4" />

        {/* Each section loads independently when user scrolls near it */}
        <LazySection minHeight="400px" data-id="element-5">
          <FrecuenciaSection data-id="element-6" />
        </LazySection>

        <LazySection minHeight="400px" data-id="element-7">
          <CienciaSection data-id="element-8" />
        </LazySection>

        <LazySection minHeight="500px" data-id="element-9">
          <ProtocoloSection handlePurchase={handlePurchase} data-id="element-10" />
        </LazySection>

        <LazySection minHeight="400px" data-id="element-11">
          <TestimoniosSection data-id="element-12" />
        </LazySection>

        <LazySection minHeight="500px" id="hoy-te-llevas" data-id="element-13">
          <HoyTeLlevasSection handlePurchase={handlePurchase} data-id="element-14" />
        </LazySection>

        <LazySection minHeight="400px" data-id="element-15">
          <IdentitySection handlePurchase={handlePurchase} data-id="element-16" />
        </LazySection>
      </main>

      <LazySection minHeight="100px" data-id="element-17">
        <Footer data-id="element-18" />
      </LazySection>

      {/* Sales notification deferred until user has been on page */}
      {showNotification && <Suspense fallback={null} data-id="element-19">
          <SalesNotification data-id="element-20" />
        </Suspense>}

      {upsellStep !== 'none' && <div className="fixed inset-0 z-[30000] flex items-center justify-center p-4 bg-dark/98 backdrop-blur-xl animate-fadeInUp" data-id="element-21">
          <div className="bg-[#0f0f11] border-2 border-gold/40 rounded-2xl max-w-md w-full shadow-[0_0_60px_rgba(212,175,55,0.2)] relative overflow-hidden" data-id="element-22">
            {/* Progress indicator */}
            <div className="absolute top-0 left-0 w-full h-1 bg-white/5" data-id="element-23">
              <div className="h-full bg-gold animate-progress" style={{
            width: '70%'
          }} data-id="element-24" />
            </div>

            {upsellStep === 'upsell' ? <div className="animate-scaleIn" data-id="element-25">
                {/* Header */}
                <div className="bg-gold/10 border-b border-gold/20 px-6 pt-8 pb-5 text-center" data-id="element-26">
                  <span className="text-gold text-[10px] font-black tracking-[3px] uppercase" data-id="element-27">
                    Oferta Especial — Solo Hoy
                  </span>
                  <h3 className="font-serif text-2xl sm:text-3xl text-white mt-3 leading-tight" data-id="element-28">
                    Potencia Tu Resultado
                  </h3>
                </div>

                {/* Body */}
                <div className="px-6 py-6" data-id="element-29">
                  <p className="text-white/80 text-sm leading-relaxed mb-6" data-id="element-30">
                    Añade el{' '}
                    <span className="text-gold font-bold" data-id="element-31">
                      Código de Riqueza Suprema
                    </span>{' '}
                    a tu pedido y acelera tu transformación con técnicas
                    avanzadas de manifestación.
                  </p>

                  {/* What you get */}
                  <div className="space-y-2.5 mb-6" data-id="element-32">
                    <div className="flex items-center gap-2.5 text-sm" data-id="element-33">
                      <span className="text-gold" data-id="element-34">✓</span>
                      <span className="text-white/90" data-id="element-35">
                        Protocolo de Manifestación en 72 horas
                      </span>
                    </div>
                    <div className="flex items-center gap-2.5 text-sm" data-id="element-36">
                      <span className="text-gold" data-id="element-37">✓</span>
                      <span className="text-white/90" data-id="element-38">
                        Técnicas avanzadas de colapso de tiempo
                      </span>
                    </div>
                    <div className="flex items-center gap-2.5 text-sm" data-id="element-39">
                      <span className="text-gold" data-id="element-40">✓</span>
                      <span className="text-white/90" data-id="element-41">
                        Guía paso a paso de activación
                      </span>
                    </div>
                  </div>

                  {/* Price breakdown */}
                  <div className="bg-white/5 rounded-xl p-4 mb-6 space-y-2" data-id="element-42">
                    <div className="flex justify-between text-sm text-white/60" data-id="element-43">
                      <span data-id="element-44">Tu Manual Maestro</span>
                      <span data-id="element-45">$14.00</span>
                    </div>
                    <div className="flex justify-between text-sm text-gold font-bold" data-id="element-46">
                      <span data-id="element-47">+ Código de Riqueza Suprema</span>
                      <span data-id="element-48">$9.00</span>
                    </div>
                    <div className="border-t border-white/10 pt-2 flex justify-between text-base font-black" data-id="element-49">
                      <span className="text-white" data-id="element-50">Total</span>
                      <span className="text-gold" data-id="element-51">$23.00</span>
                    </div>
                  </div>

                  {/* CTA */}
                  <button onClick={() => {
              window.location.href = URL_CON_UPSELL_FULL;
            }} className="w-full bg-gold text-dark py-4 rounded-xl font-black uppercase text-sm shadow-[0_8px_25px_rgba(212,175,55,0.3)] transition-all hover:scale-[1.03] hover:bg-[#f1c40f] active:scale-95" data-id="element-52">
                    SÍ, AÑADIR POR SOLO $9 MÁS
                  </button>

                  <button onClick={() => setUpsellStep('downsell')} className="w-full text-white/30 text-xs mt-4 hover:text-white/60 transition-colors" data-id="element-53">
                    No gracias, continuar solo con el manual
                  </button>
                </div>
              </div> : <div className="animate-fadeInUp" data-id="element-54">
                {/* Header */}
                <div className="bg-red-500/10 border-b border-red-500/20 px-6 pt-8 pb-5 text-center" data-id="element-55">
                  <span className="bg-red-500 text-white text-[10px] font-black py-1 px-3 rounded-full inline-block mb-3" data-id="element-56">
                    35% DESCUENTO APLICADO
                  </span>
                  <h3 className="font-serif text-2xl sm:text-3xl text-white leading-tight" data-id="element-57">
                    Una Última Oportunidad
                  </h3>
                </div>

                {/* Body */}
                <div className="px-6 py-6" data-id="element-58">
                  <p className="text-white/80 text-sm leading-relaxed mb-6" data-id="element-59">
                    Hemos aplicado un{' '}
                    <span className="text-gold font-bold" data-id="element-60">
                      descuento exclusivo del 35%
                    </span>{' '}
                    al Código de Riqueza Suprema para que puedas acceder al
                    sistema completo hoy.
                  </p>

                  {/* Price comparison */}
                  <div className="bg-white/5 rounded-xl p-4 mb-6" data-id="element-61">
                    <div className="flex justify-between items-center mb-2" data-id="element-62">
                      <span className="text-white/50 text-sm" data-id="element-63">
                        Precio normal del sistema
                      </span>
                      <span className="text-white/40 text-sm line-through" data-id="element-64">
                        $23.00
                      </span>
                    </div>
                    <div className="flex justify-between items-center pt-2 border-t border-white/10" data-id="element-65">
                      <span className="text-white font-bold text-sm" data-id="element-66">
                        Tu precio con descuento
                      </span>
                      <span className="text-gold text-xl font-black" data-id="element-67">
                        $19.85
                      </span>
                    </div>
                    <p className="text-gold/60 text-[10px] mt-2 text-right" data-id="element-68">
                      Manual + Código de Riqueza incluidos
                    </p>
                  </div>

                  {/* CTA */}
                  <button onClick={() => {
              window.location.href = URL_CON_UPSELL_DOWNSELL;
            }} className="w-full bg-gold text-dark py-4 rounded-xl font-black uppercase text-sm shadow-[0_8px_25px_rgba(212,175,55,0.3)] transition-all hover:scale-[1.03] hover:bg-[#f1c40f] active:scale-95" data-id="element-69">
                    ACTIVAR DESCUENTO — $19.85
                  </button>

                  <button onClick={() => {
              window.location.href = URL_SOLO_EBOOK;
            }} className="w-full text-white/30 text-xs mt-4 hover:text-white/60 transition-colors" data-id="element-70">
                    No gracias, ir al checkout solo con el manual ($14)
                  </button>
                </div>
              </div>}
          </div>
        </div>}
    </div>;
}